<template>
  <document-number-template-form></document-number-template-form>
</template>

<script>
import DocumentNumberTemplateForm from "../../../../components/Settings/DocumentNumberTemplateForm";
export default {
  name: "SettingsSystemSettingsDocumentNumberTemplateNewView",
  components: { DocumentNumberTemplateForm }
};
</script>

<style scoped></style>
